var React = require('react');

function HealthFacility (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Layer_2_1_"},React.createElement("g",{"id":"Icons"},React.createElement("path",{"fill":"currentColor","d":"M18.7,0.3c-0.4-0.3-0.9-0.3-1.3,0l-17,15.4C0.1,15.9,0,16.2,0,16.4V44h36V16.4c0-0.3-0.1-0.6-0.3-0.7\n\t\t\tL18.7,0.3z M25,29h-4v4c0,1.7-1.3,3-3,3s-3-1.3-3-3v-4h-4c-1.7,0-3-1.3-3-3s1.3-3,3-3h4v-4c0-1.7,1.3-3,3-3s3,1.3,3,3v4h4\n\t\t\tc1.7,0,3,1.3,3,3S26.7,29,25,29z"}))));
}

HealthFacility.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 36 44","style":{"enableBackground":"new 0 0 36 44"},"xmlSpace":"preserve"};

module.exports = HealthFacility;

HealthFacility.default = HealthFacility;
